export const statusLookup: Array<any> = [
  { id: 0, status: 'Valid'},
  { id: 1, status: 'Invalid'},
  { id: 2, status: 'Duplicate'},
];
